import { render, staticRenderFns } from "./BaseTab.vue?vue&type=template&id=1b0a8f90&scoped=true&"
import script from "./BaseTab.vue?vue&type=script&lang=ts&"
export * from "./BaseTab.vue?vue&type=script&lang=ts&"
import style0 from "./BaseTab.vue?vue&type=style&index=0&id=1b0a8f90&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0a8f90",
  null
  
)

export default component.exports